import { gql } from '@apollo/client';

// Recipients Preview Query
export const GET_RECIPIENTS_PREVIEW_QUERY = gql`
  query GetRecipientsPreview($manifest: String!) {
    getRecipientsPreview(manifest: $manifest) {
      base {
        email
        name
        type
      }
      byConsignee {
        consigneeName
        bill_of_lading
        ffUser {
          id
          full_name
          email
        }
        recipients {
          email
          name
          type
        }
      }
    }
  }
`;

// Recipients Preview Query for Temporary Data
export const GET_RECIPIENTS_PREVIEW_TEMP_QUERY = gql`
  query GetRecipientsPreviewTemp($tempShipmentData: TempShipmentDataInput!) {
    getRecipientsPreviewTemp(tempShipmentData: $tempShipmentData) {
      base {
        email
        name
        type
      }
      byConsignee {
        consigneeName
        bill_of_lading
        ffUser {
          id
          full_name
          email
        }
        recipients {
          email
          name
          type
        }
      }
    }
  }
`;

// Authentication Queries
// User Queries
export const USERS_QUERY = gql`
  query Users {
    users {
      id
      email
      full_name
      is_active
      role {
        id
        role_name
      }
    }
  }
`;

// Shipment Queries
export const ACTIVE_SHIPMENTS_QUERY = gql`
  query ActiveShipments {
    activeShipments {
      manifest
      reference
      in_transit
      notes
      created_at
      origin {
        origin_name
      }
      destination {
        destination_name
      }
      loggedUser {
        id
        full_name
      }
      details {
        bill_of_lading
        commercial_invoice
        consignee {
          id
          full_name
        }
        suppliers {
          id
          supplier_name
        }
      }
      events {
        id
        status_detail
        status_date
        approved
        created_at
      }
    }
  }
`;

export const ACTIVE_SHIPMENTS_FOR_UPDATES_QUERY = gql`
  query ActiveShipmentsForUpdates {
    activeShipmentsForUpdates {
      manifest
      reference
      origin {
        origin_name
      }
      destination {
        destination_name
      }
      details {
        bill_of_lading
        commercial_invoice
        consigneeId
        ff
        cif
        seller
        additional_consignees
        consignee {
          id
          full_name
        }
        suppliers {
          id
        }
        ffUser {
          id
          full_name
          email
        }
      }
    }
  }
`;

export const COMPLETED_SHIPMENTS_QUERY = gql`
  query CompletedShipments {
    completedShipments {
      manifest
      reference
      in_transit
      notes
      created_at
      delivered_at
      origin {
        origin_name
      }
      destination {
        destination_name
      }
      loggedUser {
        id
        full_name
      }
      details {
        bill_of_lading
        commercial_invoice
        consignee {
          id
          full_name
        }
        suppliers {
          id
          supplier_name
        }
      }
      events {
        id
        status_detail
        status_date
        approved
        created_at
      }
    }
  }
`;

// Queries for Cliente/Seller/Notificado roles (ShipmentDetailsView)
export const ACTIVE_SHIPMENT_DETAILS_CLIENT_QUERY = gql`
  query ActiveShipmentDetailsForClient {
    activeShipmentDetailsForClient {
      manifest
      bill_of_lading
      commercial_invoice
      reference
      in_transit
      created_at
      delivered_at
      consignee {
        id
        full_name
      }
      suppliers {
        id
        supplier_name
      }
      shipment {
        origin {
          origin_name
        }
        destination {
          destination_name
        }
        loggedUser {
          id
          full_name
        }
        events {
          id
          status_detail
          status_date
          approved
          created_at
        }
      }
    }
  }
`;

export const COMPLETED_SHIPMENT_DETAILS_CLIENT_QUERY = gql`
  query CompletedShipmentDetailsForClient {
    completedShipmentDetailsForClient {
      manifest
      bill_of_lading
      commercial_invoice
      reference
      in_transit
      created_at
      delivered_at
      consignee {
        id
        full_name
      }
      suppliers {
        id
        supplier_name
      }
      shipment {
        origin {
          origin_name
        }
        destination {
          destination_name
        }
        loggedUser {
          id
          full_name
        }
        events {
          id
          status_detail
          status_date
          approved
          created_at
        }
      }
    }
  }
`;

export const ACTIVE_SHIPMENT_DETAILS_SELLER_QUERY = gql`
  query ActiveShipmentDetailsForSeller {
    activeShipmentDetailsForSeller {
      manifest
      bill_of_lading
      commercial_invoice
      reference
      in_transit
      created_at
      delivered_at
      consignee {
        id
        full_name
      }
      suppliers {
        id
        supplier_name
      }
      shipment {
        origin {
          origin_name
        }
        destination {
          destination_name
        }
        loggedUser {
          id
          full_name
        }
        events {
          id
          status_detail
          status_date
          approved
          created_at
        }
      }
    }
  }
`;

export const COMPLETED_SHIPMENT_DETAILS_SELLER_QUERY = gql`
  query CompletedShipmentDetailsForSeller {
    completedShipmentDetailsForSeller {
      manifest
      bill_of_lading
      commercial_invoice
      reference
      in_transit
      created_at
      delivered_at
      consignee {
        id
        full_name
      }
      suppliers {
        id
        supplier_name
      }
      shipment {
        origin {
          origin_name
        }
        destination {
          destination_name
        }
        loggedUser {
          id
          full_name
        }
        events {
          id
          status_detail
          status_date
          approved
          created_at
        }
      }
    }
  }
`;

export const ACTIVE_SHIPMENT_DETAILS_NOTIFICADO_QUERY = gql`
  query ActiveShipmentDetailsForNotificado {
    activeShipmentDetailsForNotificado {
      manifest
      bill_of_lading
      commercial_invoice
      reference
      in_transit
      created_at
      delivered_at
      consignee {
        id
        full_name
      }
      suppliers {
        id
        supplier_name
      }
      shipment {
        origin {
          origin_name
        }
        destination {
          destination_name
        }
        loggedUser {
          id
          full_name
        }
        events {
          id
          status_detail
          status_date
          approved
          created_at
        }
      }
    }
  }
`;

export const COMPLETED_SHIPMENT_DETAILS_NOTIFICADO_QUERY = gql`
  query CompletedShipmentDetailsForNotificado {
    completedShipmentDetailsForNotificado {
      manifest
      bill_of_lading
      commercial_invoice
      reference
      in_transit
      created_at
      delivered_at
      consignee {
        id
        full_name
      }
      suppliers {
        id
        supplier_name
      }
      shipment {
        origin {
          origin_name
        }
        destination {
          destination_name
        }
        loggedUser {
          id
          full_name
        }
        events {
          id
          status_detail
          status_date
          approved
          created_at
        }
      }
    }
  }
`;

// CRUD Queries
export const ORIGINS_QUERY = gql`
  query Origins {
    origins {
      id
      origin_name
      email
    }
  }
`;

export const DESTINATIONS_QUERY = gql`
  query Destinations {
    destinations {
      id
      destination_name
      email
    }
  }
`;

export const SUPPLIERS_QUERY = gql`
  query Suppliers {
    suppliers {
      id
      supplier_name
      email
    }
  }
`;

// Metrics Query
export const SHIPMENT_METRICS_QUERY = gql`
  query ShipmentMetrics {
    shipmentMetrics {
      inTransit
      completed
      unapprovedEvents
      totalShipments
    }
  }
`;

// Unapproved Events Query
export const UNAPPROVED_EVENTS_QUERY = gql`
  query UnapprovedEvents {
    unapprovedEvents {
      id
      manifest
      status_detail
      status_date
      created_at
      shipment {
        manifest
        reference
        in_transit
        created_at
        delivered_at
        notes
        origin {
          origin_name
        }
        destination {
          destination_name
        }
        loggedUser {
          id
          full_name
        }
        events {
          id
          status_detail
          status_date
          approved
          created_at
        }
        details {
          bill_of_lading
          commercial_invoice
          consignee {
            id
            full_name
          }
          suppliers {
            id
            supplier_name
          }
          ff
          ffUser {
            id
            full_name
            email
          }
        }
      }
    }
  }
`;

// Shipment Details by Manifest Query (used by BLsModal)
export const SHIPMENT_DETAILS_BY_MANIFEST_QUERY = gql`
  query GetShipmentDetailsByManifest($manifest: String!) {
    getShipmentDetailsByManifest(manifest: $manifest) {
      bill_of_lading
      commercial_invoice
      additional_consignees
      cif
      shipment {
        reference
        created_at
      }
      consignee {
        id
        full_name
        email
      }
      suppliers {
        id
        supplier_name
        email
      }
      ffUser {
        id
        full_name
        email
      }
      sellerUser {
        id
        full_name
        email
      }
    }
  }
`;

// Check Pending Events Query
export const CHECK_PENDING_EVENTS_QUERY = gql`
  query CheckPendingEvents($manifest: String!) {
    checkPendingEvents(manifest: $manifest) {
      hasPendingEvents
      pendingEventsCount
      pendingEvents {
        id
        status_detail
        status_date
        created_at
      }
    }
  }
`;

// Editable Manifests Query
export const GET_EDITABLE_MANIFESTS_QUERY = gql`
  query GetEditableManifests {
    getEditableManifests {
      manifest
      reference
      origin_name
      destination_name
      driver
      originId
      destinationId
      driver_passport
      driver_license
      driver_phone
      notes
      created_at
      details {
        bill_of_lading
        commercial_invoice
        consigneeId
        ff
        seller
        cif
        additional_consignees
        consignee {
          id
          full_name
          email
        }
        suppliers {
          id
          supplier_name
          email
        }
        ffUser {
          id
          full_name
          email
        }
        sellerUser {
          id
          full_name
          email
        }
      }
      events {
        id
        status_detail
        status_date
        approved
      }
    }
  }
`;
